module.exports = __webpack_public_path__ + "img/seller_amend posting category.e93d0821.svg";